function getMarketDataAuth(callback) {
    $.ajax(SBDatafeed.Static.authURI, {success: callback});
}

function createChart(credentials, extended, uniqueId, overwrite, orderData) {
    var config, datafeed, instance;

    datafeed = new SBDatafeed(credentials, uniqueId, overwrite, orderData);

    config = $.extend({}, SBDatafeed.Static.defaultWidgetConfig, {
        datafeed: datafeed
    }, extended);

    instance = new TradingView.widget(config);
    datafeed.informInstance(instance);

    return instance;
}

window.createChart = createChart;

